import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'fs-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.sass'],
  encapsulation: ViewEncapsulation.None
})
export class LoaderComponent {
  @Input() isLoading = false;

  constructor() { }
}
